module.exports = __webpack_public_path__ + "static/multiple_files180-d4baa3f7146fc1cb4887f7c2a604da1e.png";